
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexySpc_8Q8YteEXiVq0pxgi7MaafGeuQ9IL6GZnFGV17kMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/index.vue?macro=true";
import { default as astuces2QRl0i_bT6hh9MTVUyQYFkPNOCvp0D22gZI_45gmDvDVkMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/astuces.vue?macro=true";
import { default as landing6s9pF9UiSzNmqOzhkrwKTV2aXmgzRmV8HU_457p8rW92sMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/landing.vue?macro=true";
import { default as astrobotXBPslx26KUeXBei9wJxvNfOkU7hVRnGWidJYB2b8mHkMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/astrobot.vue?macro=true";
import { default as avantageskup8cNQMpQSRpN9NURu1AA61rgkmL0r5PjzOzgKW9x0Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avantages.vue?macro=true";
import { default as rechercheS_zeTQKW_45OulDl92dxckYH3_451dZab1xG8rOCfkoa4LYMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/recherche.vue?macro=true";
import { default as challengesGPSAQg8N4pqkOifxcgemGCBqI0x6KmpFsMNe8kq23M8Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/challenges.vue?macro=true";
import { default as mon_45profilnD7bxE9InpMeor3ezKYYY5chC_kxFF3SPNxzXOu5Z8EMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/mon-profil.vue?macro=true";
import { default as avis_45mediasgYgF7qztQO0zRUKXJmPLij4fByBJ4hYxMIdLnUaKVEIMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avis-medias.vue?macro=true";
import { default as inscriptions1JyCTZOyT8mzwB_45G9Hm_45A6wy85HB7gPqiFuPEppo5MMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/inscription.vue?macro=true";
import { default as avis_45joueurstNYh4ls_45RNKgovm_eonGoSQWbRNZdnutSnDy5GP32iwMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avis-joueurs.vue?macro=true";
import { default as indexy0bVLMKiWl9VNhbbxf2uvkwFgSZVU61vJjipv_2B7cUMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/offres/index.vue?macro=true";
import { default as indexSJ8_45FY1LznTmViK0TdZeUxH8Il9pLhgCdmhNIHP78iMMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/wapers/index.vue?macro=true";
import { default as index6iQ2u4qskeykZs4eSMNJFVwx6MniYgbrKdzTJNEd_pEMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours/index.vue?macro=true";
import { default as _91pageName_93CZa3MtJRs9RmwXt70BZ8QNgvTkOrTEs5xIwgSafiowEMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/page/[pageName].vue?macro=true";
import { default as indexObZYPc77_45tMw_45TPEccZiQB563d4Wo6e9qdJoSL5mutcMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/index.vue?macro=true";
import { default as _91nickname_93PsZjkIyqfEZ9jud_X85YV0RdnbnB7spFS5cEpmx7abQMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/wapers/[nickname].vue?macro=true";
import { default as _91offerName_937IFXANAreA0mAJldCSe_45DMtHorcnJ3OuOebS5l36SCkMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/offres/[offerName].vue?macro=true";
import { default as le_45feed_45des_45players0B7ENrtlSgROV2mO26V9dZPdX1_45PU3f2RybiRzmujp4Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/le-feed-des-players.vue?macro=true";
import { default as actualites_45communautesxJVtHmD31EyLKpGGrN7OLTo7bFpAAHre9_45JW5Ef6oIgMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-communautes.vue?macro=true";
import { default as _91contestName_93_xVxPjbRrYKpBHGEsZqPdw1nrstQ_455p_45MS3iHuyrsEcMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours/[contestName].vue?macro=true";
import { default as _91tournamentName_93efT357JFD20YFfVeYhTGzdjLzMWgTIlzqZl6v2nvFJQMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/tournoi/[tournamentName].vue?macro=true";
import { default as _91challengeName_9352uzlm_BJ7jDMoSXpSIjqZDv_45GkNH3QCjVINK3Ed_YgMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/challenge/[challengeName].vue?macro=true";
import { default as _91contestName_939i_45UjJlzb_45V8xE1P_TCYkjgZeihKDymB6PJQ7XIABdsMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/jeu-concours/[contestName].vue?macro=true";
import { default as _91typeName_93FHee_45fcVp46qP6ZnWhdmi9zcoI36ooF6Q6sO4Yq__45QcMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/type/[typeName].vue?macro=true";
import { default as indexpbNxeX4iWhy_8Qn7zk0q6K_SylmjIgN64LsDBaFaPYUMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/index.vue?macro=true";
import { default as _91title_93M_48nxsyyxaFgYBuWo9y1UeNjLKiETRQ_45AjPaWGSU4gMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/[title].vue?macro=true";
import { default as _91genderName_93WQ8DapMBBPnxdasK_WLff5g2YTBhUxnvdl28svy_JBoMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/genre/[genderName].vue?macro=true";
import { default as indexvPG1vx2tS_45N7kYwDhu0Bli6R9Udtt4mzLxyteNrhYEIMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/index.vue?macro=true";
import { default as _91contestName_939x8t7i64n_4tFDB5NAT0lIlFiEJuVJc3FWkR1raH95wMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours-classement/[contestName].vue?macro=true";
import { default as indexoquMhSsHR6wuuPk7vvaotPgQJKEVqaF9yf1wl_V5MFkMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue?macro=true";
import { default as index2F1cl0gBGSby329RQNFs2dMAf2Wyr0AWESKIUrOvPw0Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue?macro=true";
import { default as concours_45stellar_45bladeu4LmmgEWxGQRpJE9XsXkJw62i_Dz9PGTrHlukYsm2LEMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue?macro=true";
import { default as indexr9gXOjajzIljb3TUIqpYOwBLxxU3oTcRLu7OsZXQiKYMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue?macro=true";
import { default as indexTXXeTFKeDqn6vhEDBXsuskC_45Rhf82n4O8aPt3PpXr2EMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue?macro=true";
import { default as _91postTitle_93wB8UNsqVkF_45rwXrFqsSbe30LzTc17nQjfczJ47XHqQAMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue?macro=true";
import { default as indexDcAcYk9ktr5E_QZdUGLV8aSYrm7OhL9HM8XDpe7zxIQMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue?macro=true";
import { default as indexPpbr9TQZ4SR_45Uy_455NNXF_8agEQG88LgX1rMGvU2_0IUMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue?macro=true";
import { default as indexohMV4HMVxWtmkQr3_45oNMYa70IdfUmFyDGVgDdxS0CRQMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93FtycDNz_45HdQmsGWDsNNk11zN_45Y2EAO4_eAzEcpmCLoMMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue?macro=true";
import { default as _91postTitle_93rsAV1Mmc0YwvkpyeI8PDPCLycQ_388gUNNTrFHcVK0sMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue?macro=true";
import { default as _91postTitle_93eRSYnXL_452h3UtcFU2v2Dv92l3lgLy7IJMBwZrKqNwXoMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue?macro=true";
import { default as indexBY6kgw0GUOYM0QyINBq_BOCbAZjHj_45qC_QsdcLIaEK4Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93sdYjlhU5luUIs7NevJwhB5xqZr2Ob4gC6diXwCPK5B4Meta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue?macro=true";
import { default as component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY } from "/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/index.vue")
  },
  {
    name: "astuces",
    path: "/astuces",
    meta: astuces2QRl0i_bT6hh9MTVUyQYFkPNOCvp0D22gZI_45gmDvDVkMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/astuces.vue")
  },
  {
    name: "landing",
    path: "/landing",
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/landing.vue")
  },
  {
    name: "astrobot",
    path: "/astrobot",
    meta: astrobotXBPslx26KUeXBei9wJxvNfOkU7hVRnGWidJYB2b8mHkMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/astrobot.vue")
  },
  {
    name: "avantages",
    path: "/avantages",
    meta: avantageskup8cNQMpQSRpN9NURu1AA61rgkmL0r5PjzOzgKW9x0Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avantages.vue")
  },
  {
    name: "recherche",
    path: "/recherche",
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/recherche.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    meta: challengesGPSAQg8N4pqkOifxcgemGCBqI0x6KmpFsMNe8kq23M8Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/challenges.vue")
  },
  {
    name: "mon-profil",
    path: "/mon-profil",
    meta: {"middleware":["temp-auth"]},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/mon-profil.vue")
  },
  {
    name: "avis-medias",
    path: "/avis-medias",
    meta: avis_45mediasgYgF7qztQO0zRUKXJmPLij4fByBJ4hYxMIdLnUaKVEIMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avis-medias.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/inscription.vue")
  },
  {
    name: "avis-joueurs",
    path: "/avis-joueurs",
    meta: avis_45joueurstNYh4ls_45RNKgovm_eonGoSQWbRNZdnutSnDy5GP32iwMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/avis-joueurs.vue")
  },
  {
    name: "offres",
    path: "/offres",
    meta: indexy0bVLMKiWl9VNhbbxf2uvkwFgSZVU61vJjipv_2B7cUMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/offres/index.vue")
  },
  {
    name: "wapers",
    path: "/wapers",
    meta: indexSJ8_45FY1LznTmViK0TdZeUxH8Il9pLhgCdmhNIHP78iMMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/wapers/index.vue")
  },
  {
    name: "concours",
    path: "/concours",
    meta: index6iQ2u4qskeykZs4eSMNJFVwx6MniYgbrKdzTJNEd_pEMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours/index.vue")
  },
  {
    name: "page-pageName",
    path: "/page/:pageName()",
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/page/[pageName].vue")
  },
  {
    name: "communautes",
    path: "/communautes",
    meta: indexObZYPc77_45tMw_45TPEccZiQB563d4Wo6e9qdJoSL5mutcMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/index.vue")
  },
  {
    name: "wapers-nickname",
    path: "/wapers/:nickname()",
    meta: _91nickname_93PsZjkIyqfEZ9jud_X85YV0RdnbnB7spFS5cEpmx7abQMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/wapers/[nickname].vue")
  },
  {
    name: "offres-offerName",
    path: "/offres/:offerName()",
    meta: _91offerName_937IFXANAreA0mAJldCSe_45DMtHorcnJ3OuOebS5l36SCkMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/offres/[offerName].vue")
  },
  {
    name: "le-feed-des-players",
    path: "/le-feed-des-players",
    meta: le_45feed_45des_45players0B7ENrtlSgROV2mO26V9dZPdX1_45PU3f2RybiRzmujp4Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/le-feed-des-players.vue")
  },
  {
    name: "actualites-communautes",
    path: "/actualites-communautes",
    meta: actualites_45communautesxJVtHmD31EyLKpGGrN7OLTo7bFpAAHre9_45JW5Ef6oIgMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-communautes.vue")
  },
  {
    name: "concours-contestName",
    path: "/concours/:contestName()",
    meta: _91contestName_93_xVxPjbRrYKpBHGEsZqPdw1nrstQ_455p_45MS3iHuyrsEcMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours/[contestName].vue")
  },
  {
    name: "tournoi-tournamentName",
    path: "/tournoi/:tournamentName()",
    meta: _91tournamentName_93efT357JFD20YFfVeYhTGzdjLzMWgTIlzqZl6v2nvFJQMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/tournoi/[tournamentName].vue")
  },
  {
    name: "challenge-challengeName",
    path: "/challenge/:challengeName()",
    meta: _91challengeName_9352uzlm_BJ7jDMoSXpSIjqZDv_45GkNH3QCjVINK3Ed_YgMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/challenge/[challengeName].vue")
  },
  {
    name: "jeu-concours-contestName",
    path: "/jeu-concours/:contestName()",
    meta: _91contestName_939i_45UjJlzb_45V8xE1P_TCYkjgZeihKDymB6PJQ7XIABdsMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/jeu-concours/[contestName].vue")
  },
  {
    name: "communautes-type-typeName",
    path: "/communautes/type/:typeName()",
    meta: _91typeName_93FHee_45fcVp46qP6ZnWhdmi9zcoI36ooF6Q6sO4Yq__45QcMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/type/[typeName].vue")
  },
  {
    name: "actualites-playstation",
    path: "/actualites-playstation",
    meta: indexpbNxeX4iWhy_8Qn7zk0q6K_SylmjIgN64LsDBaFaPYUMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/index.vue")
  },
  {
    name: "actualites-playstation-title",
    path: "/actualites-playstation/:title()",
    meta: _91title_93M_48nxsyyxaFgYBuWo9y1UeNjLKiETRQ_45AjPaWGSU4gMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/[title].vue")
  },
  {
    name: "communautes-genre-genderName",
    path: "/communautes/genre/:genderName()",
    meta: _91genderName_93WQ8DapMBBPnxdasK_WLff5g2YTBhUxnvdl28svy_JBoMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/genre/[genderName].vue")
  },
  {
    name: "communautes-communityName",
    path: "/communautes/:communityName()",
    meta: indexvPG1vx2tS_45N7kYwDhu0Bli6R9Udtt4mzLxyteNrhYEIMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/index.vue")
  },
  {
    name: "concours-classement-contestName",
    path: "/concours-classement/:contestName()",
    meta: _91contestName_939x8t7i64n_4tFDB5NAT0lIlFiEJuVJc3FWkR1raH95wMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/concours-classement/[contestName].vue")
  },
  {
    name: "communautes-communityName-wapers",
    path: "/communautes/:communityName()/wapers",
    meta: indexoquMhSsHR6wuuPk7vvaotPgQJKEVqaF9yf1wl_V5MFkMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue")
  },
  {
    name: "communautes-communityName-astuces",
    path: "/communautes/:communityName()/astuces",
    meta: index2F1cl0gBGSby329RQNFs2dMAf2Wyr0AWESKIUrOvPw0Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue")
  },
  {
    name: "actualites-playstation-concours-stellar-blade",
    path: "/actualites-playstation/concours-stellar-blade",
    meta: concours_45stellar_45bladeu4LmmgEWxGQRpJE9XsXkJw62i_Dz9PGTrHlukYsm2LEMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue")
  },
  {
    name: "communautes-communityName-avis-medias",
    path: "/communautes/:communityName()/avis-medias",
    meta: indexr9gXOjajzIljb3TUIqpYOwBLxxU3oTcRLu7OsZXQiKYMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs",
    path: "/communautes/:communityName()/avis-joueurs",
    meta: indexTXXeTFKeDqn6vhEDBXsuskC_45Rhf82n4O8aPt3PpXr2EMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue")
  },
  {
    name: "communautes-communityName-avis-medias-postTitle",
    path: "/communautes/:communityName()/avis-medias/:postTitle()",
    meta: _91postTitle_93wB8UNsqVkF_45rwXrFqsSbe30LzTc17nQjfczJ47XHqQAMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players",
    path: "/communautes/:communityName()/le-feed-des-players",
    meta: indexDcAcYk9ktr5E_QZdUGLV8aSYrm7OhL9HM8XDpe7zxIQMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue")
  },
  {
    name: "communautes-communityName-actualites-communaute",
    path: "/communautes/:communityName()/actualites-communaute",
    meta: indexPpbr9TQZ4SR_45Uy_455NNXF_8agEQG88LgX1rMGvU2_0IUMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName",
    path: "/communautes/:communityName()/astuces/:subCategoryName()",
    meta: indexohMV4HMVxWtmkQr3_45oNMYa70IdfUmFyDGVgDdxS0CRQMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs-detail-postTitle",
    path: "/communautes/:communityName()/avis-joueurs/detail/:postTitle()",
    meta: _91postTitle_93FtycDNz_45HdQmsGWDsNNk11zN_45Y2EAO4_eAzEcpmCLoMMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue")
  },
  {
    name: "communautes-communityName-actualites-communaute-postTitle",
    path: "/communautes/:communityName()/actualites-communaute/:postTitle()",
    meta: _91postTitle_93rsAV1Mmc0YwvkpyeI8PDPCLycQ_388gUNNTrFHcVK0sMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName-postTitle",
    path: "/communautes/:communityName()/astuces/:subCategoryName()/:postTitle()",
    meta: _91postTitle_93eRSYnXL_452h3UtcFU2v2Dv92l3lgLy7IJMBwZrKqNwXoMeta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()",
    meta: indexBY6kgw0GUOYM0QyINBq_BOCbAZjHj_45qC_QsdcLIaEK4Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName-postTitle",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()/:postTitle()",
    meta: _91postTitle_93sdYjlhU5luUIs7NevJwhB5xqZr2Ob4gC6diXwCPK5B4Meta || {},
    component: () => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue")
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/le-coin-des-wapers",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/0-sitemap.xml",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/1-sitemap.xml",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/2-sitemap.xml",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/3-sitemap.xml",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  },
  {
    name: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubmwDHZ7MlFWcg3sEMl94NSXVIUDIRM2maR2E5rvIhlHY
  }
]